var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChecklistHeaderRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#E5EDFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.156 15.938c.406.218.781.468 1.094.812.344.313.594.688.813 1.094 3.28-.938 4.875-2.5 5.656-3.938.781-1.469.843-3.062.687-4.312-1.25-.156-2.843-.094-4.312.687-1.438.781-3 2.375-3.938 5.656zM20 17.78v2.563c0 .781-.438 1.531-1.125 1.937l-2.75 1.625c-.25.157-.531.157-.75 0-.25-.125-.375-.375-.375-.656v-3.563c0-.718-.281-1.406-.781-1.906S13.03 17 12.313 17H8.75c-.281 0-.531-.125-.656-.375-.156-.219-.156-.5 0-.75l1.625-2.75A2.284 2.284 0 0 1 11.656 12h2.563c2.562-4.094 6.531-4.25 8.875-3.813a.862.862 0 0 1 .718.72c.438 2.343.282 6.312-3.812 8.874zM8.875 24A.82.82 0 0 1 8 23.125c.031-1.188.219-3.25 1.313-4.313a2.754 2.754 0 0 1 3.874 0 2.754 2.754 0 0 1 0 3.875C12.126 23.782 10.063 23.97 8.875 24zm1.563-2c.406-.031.968-.125 1.28-.438a.87.87 0 0 0 0-1.28.87.87 0 0 0-1.28 0c-.313.312-.407.874-.438 1.28 0 .25.188.438.438.438zm7.812-9.5c0-.438.219-.844.625-1.063a1.272 1.272 0 0 1 1.25 0c.375.22.625.626.625 1.063 0 .469-.25.875-.625 1.094a1.272 1.272 0 0 1-1.25 0c-.406-.219-.625-.625-.625-1.094z",
    fill: "#1847CA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklistHeaderRocket);
export default __webpack_public_path__ + "static/media/checklist-header-rocket.f7ad64ebae4dea87cf4d0f804d0117c6.svg";
export { ForwardRef as ReactComponent };